<template>
  <div class="color-input-field">
    <label :for="inputId" class="label has-text-weight-normal color-input-label">
      <span>{{ label }}</span>
      <IconHint :content="hint" />
    </label>
    <div class="is-flex is-align-items-center">
      <div class="control">
        <input
          :id="inputId"
          :value="modelValue"
          type="text"
          class="input is-fullwidth"
          :class="{ 'is-disabled': disabled }"
          :disabled="disabled"
          :placeholder="disabled ? disabledPlaceholder : placeholder"
          :data-test-id="testId"
          @input.stop="handleInput"
          @blur="$emit('blur')"
        />
      </div>
      <button
        v-if="showReset"
        type="button"
        class="button is-warning ml-2"
        :title="`Reset to ${defaultColor}`"
        :aria-label="`Reset to ${defaultColor}`"
        @click="
          if (modelValue !== defaultColorHex) {
            $emit('update:modelValue', defaultColorHex);
            triggerSave?.();
          }
        "
      >
        <span class="icon is-small"><i class="fas fa-undo" aria-hidden="true"></i></span>
      </button>
    </div>
  </div>
</template>

<script setup>
  import { computed, inject } from "vue";
  import IconHint from "../icon-hint.vue";

  const props = defineProps({
    modelValue: { type: String, default: "" },
    label: { type: String, required: true },
    hint: { type: String, required: true },
    defaultColor: { type: String, required: true },
    defaultColorHex: { type: String, required: true },
    placeholder: { type: String, default: "" },
    testId: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    disabledPlaceholder: { type: String, default: "" },
    inputId: { type: String, default: "" },
  });

  const emit = defineEmits(["update:modelValue", "blur"]);
  const triggerSave = inject("triggerSave");

  function handleInput(event) {
    emit("update:modelValue", event.target.value);
  }

  const showReset = computed(() => {
    if (props.disabled) return false;
    if (!props.modelValue) return false;

    const val = props.modelValue.toLowerCase();
    const defaultHex = props.defaultColorHex.toLowerCase();
    const defaultName = props.defaultColor.toLowerCase();

    return val !== defaultHex && val !== defaultName;
  });
</script>

<style scoped>
  .color-input-field {
    flex: 1;
    min-width: 0;
  }

  .color-input-label {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    margin-bottom: 0.25rem;
  }
</style>
